import styled from 'styled-components'
import Col from 'react-bootstrap/Col'
import { H4 } from '../../../../typography'

export const ScoreCard = styled(Col)`
  text-align: center;
  padding-top: 16px;
`

interface ScoreTitleProp {
  borderColor: string
}

export const ScoreTitle = styled(H4)<ScoreTitleProp>`
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ borderColor }) => borderColor};
`

export const RankWrapper = styled.div`
  display: flex;
`
